module.exports = __webpack_public_path__ + "img/favorite_full.78496bc0.svg";